import { useUser } from '@clerk/clerk-react';
import { UserButton } from '@clerk/clerk-react';

interface UserProfileProps {
  className?: string;
  showDetails?: boolean;
}

export function UserProfile({ className = '', showDetails = false }: UserProfileProps) {
  const { user, isLoaded } = useUser();

  if (!isLoaded) {
    return (
      <div className={`animate-pulse ${className}`}>
        <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <UserButton afterSignOutUrl="/" />
      {showDetails && (
        <div className="hidden md:block">
          <p className="text-sm font-medium text-gray-900 dark:text-white">
            {user.firstName} {user.lastName}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {user.primaryEmailAddress?.emailAddress}
          </p>
        </div>
      )}
    </div>
  );
}

export default UserProfile;